export default "__VITE_ASSET__bfef9c7b__"